import { Box, Divider, Skeleton, Stack } from "@mui/material"
import { ReactElement } from "react"

import AppSkeleton from "./appSkeleton"
import AppPaper from "../../surfaces/appPaper"

/** Displayed when the user is on the my organisation page and the API is
 * loading the org
 */
const MyOrgSkeleton = (): ReactElement => (
    <Box
        width="100%"
        display="flex"
        justifyContent="center"
        flexDirection="row"
    >
        <AppPaper
            sx={{ width: { xs: "100%", md: "60%" }, p: 2 }}
            aria-label="my-org-skeleton"
        >
            <Stack spacing={2}>
                <Stack direction="row" spacing={3} alignItems="center">
                    <Skeleton
                        variant="circular"
                        width={120}
                        height={120}
                        sx={{
                            display: {
                                xs: "none",
                                md: "block",
                            },
                        }}
                    />
                    <Box width="90%">
                        <AppSkeleton variant="text" width="60%" height={48} />
                        <AppSkeleton variant="text" height={28} />
                        <AppSkeleton variant="text" height={28} />
                    </Box>
                </Stack>
                <Stack
                    direction={{ xs: "column", sm: "row" }}
                    justifyContent="flex-end"
                    spacing={2}
                >
                    <AppSkeleton
                        variant="rectangular"
                        width={160}
                        height={36}
                    />
                    <AppSkeleton
                        variant="rectangular"
                        width={160}
                        height={36}
                    />
                </Stack>
                <Divider />
                <AppSkeleton variant="rectangular" height={100} />
                <Divider />
                <AppSkeleton variant="rectangular" height={100} />
                <Divider />
                <AppSkeleton variant="rectangular" height={100} />
                <Divider />
                <AppSkeleton variant="rectangular" height={100} />
                <Divider />
                <AppSkeleton variant="rectangular" height={100} />
            </Stack>
        </AppPaper>
    </Box>
)

export default MyOrgSkeleton
